// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAEafqmekpXbkyf28hSk4CL7WiR0s6LvME',
  authDomain: 'peerxiv.firebaseapp.com',
  projectId: 'peerxiv',
  storageBucket: 'peerxiv.appspot.com',
  messagingSenderId: '687133254936',
  appId: '1:687133254936:web:b07062a7cd92e24637aa6d',
  measurementId: 'G-ZHWV82NVT7',
};

export function initAnalytics() {
  const app = initializeApp(firebaseConfig);
  // eslint-disable-next-line no-unused-vars
  const firebaseAnalytics = getAnalytics(app);
}

export function FirebaseAnalytics() {
  const location = useLocation();
  useEffect(() => {
    const analytics = window.firebase && window.firebase.analytics;
    if (typeof analytics === 'function') {
      const pagePath = location.pathname + location.search;
      console.log('pagePath', pagePath);
      analytics().setCurrentScreen(pagePath);
      analytics().logEvent('page_view', { pagePath });
    }
  }, [location]);
  return null;
}

// Initialize Firebase
